
import Boxcard from "./Boxcard"; 
import BoxcardDepartmentDetails from "./BoxcardDepartmentDetails";
import { useEffect , useState } from "react";
import FeeDetailsList from "./TodayTask"; 
import GraphDesign from "./GraphDesign";
import AvailableEmployee from "./AvailableEmployee"; 
import BusyEmployee from "./BusyEmployee";
import "./box.css";
const Dashboard = () => {
  	const [tasksViewMode, setTasksViewMode] = useState("daily");
  
  return (
    <div
      className="Dashboard flex flex-col gap-[10px] h-full overflow-y-scroll p-[10px] [&::-webkit-scrollbar]:w-2
  [&::-webkit-scrollbar-track]:rounded-full
  [&::-webkit-scrollbar-track]:bg-gray-100
  [&::-webkit-scrollbar-thumb]:rounded-full
  [&::-webkit-scrollbar-thumb]:bg-gray-300
  dark:[&::-webkit-scrollbar-track]:bg-neutral-700
  dark:[&::-webkit-scrollbar-thumb]:bg-neutral-500"
    >
      <Boxcard />
      <BoxcardDepartmentDetails />
      
      
      <div className="Dashbaord-section-last1">
        <ul>
          <li>
            <BusyEmployee />
           
          </li>
          <li>
             <AvailableEmployee /> 
          </li>
          
        </ul>
      </div>
      <div className="Dashbaord-section-last">
        <ul>
          <li>
            <GraphDesign /> 
          </li>
          <li>
            <FeeDetailsList />
          </li>
          
        </ul>
      </div>

      
    </div>
  );
};

export default Dashboard;
